import { NavMarker } from 'react-rhumb';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { makeAsyncComponent } from 'web-interactives-dashboard-ui/utils/makeAsyncUtils';
import { TABS } from 'web-interactives-dashboard-ui/constants/DetailsConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AsyncDetailsContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'details-container' */'web-interactives-dashboard-ui/containers/details/DetailsContainer'), {
  delay: 0
});
const AsyncManageContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'manage-container' */'web-interactives-dashboard-ui/containers/manage/ManageContainer'), {
  delay: 0
});
const AsyncAnalyzeContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'analyze-container' */'web-interactives-dashboard-ui/containers/analyze/AnalyzeContainer'), {
  delay: 0
});
const AsyncCreateContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'create-container' */'web-interactives-dashboard-ui/containers/create/CreateScreenContainerV2'), {
  delay: 0
});
const ManageRedirect = props => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(NavMarker, {
    name: "MANAGE_REDIRECT"
  }), /*#__PURE__*/_jsx(Redirect, {
    to: {
      pathname: '/manage/state/all',
      search: props.location.search
    }
  })]
});
const DetailsRedirect = props => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "DETAILS_REDIRECT"
    }), /*#__PURE__*/_jsx(Redirect, {
      to: {
        pathname: `/details/${props.match.params.interactiveId}/performance`,
        search: props.location.search
      }
    })]
  });
};
function Routes() {
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      component: AsyncManageContainer,
      path: "/manage/state/:state(all|draft|published|archived|scheduled|\\d+)"
    }), /*#__PURE__*/_jsx(Route, {
      component: AsyncAnalyzeContainer,
      path: "/analyze"
    }), /*#__PURE__*/_jsx(Route, {
      component: AsyncCreateContainer,
      path: "/create"
    }), /*#__PURE__*/_jsx(Route, {
      component: AsyncDetailsContainer,
      path: `/details/:interactiveId(\\d+)/:type(${TABS.PERFORMANCE}|${TABS.FORMS}|${TABS.RESULTS}|${TABS.ATTRIBUTED_FORMS})`
    }), /*#__PURE__*/_jsx(Route, {
      component: DetailsRedirect,
      path: "/details/:interactiveId(\\d+)"
    }), /*#__PURE__*/_jsx(Route, {
      path: "/",
      render: ManageRedirect
    }), /*#__PURE__*/_jsx(Route, {
      path: "/manage",
      render: ManageRedirect
    })]
  });
}
export default withRouter(Routes);